import React from "react";
import { MoreHoriz, MoveDownOutlined, Person, PresentToAll, Archive, Fullscreen } from "@mui/icons-material";
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Tooltip
 } from "@mui/material";

import { blue, green } from '@mui/material/colors';
import Service from "../../../util/Service";
import { temAcessoAoProjeto } from "../ProjetoRoot";
import { useProfile } from "../../common/useProfile";
import { TYPES } from "../../../util/ServiceWS";
import KanbanCardMoverMenu from "./KanbanCardMoverMenu";


export default function KanbanMaisAcoesMenu(props) {
    const {projeto, papeis, temAcessoBasico, cartao, action, handleMoverCard, kanban, col, handleFullScreen} = props
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const prof = useProfile();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleCriarTemplate(){
        console.log('>>handleCriarTemplate<<')

        let nome = prompt("Defina o nome do template", cartao.nome);

        console.log( nome )
        if( nome ){
            let card = {...cartao}
            card.nome = nome;
            Service.POST("/api/security/projeto/kanban/criarTemplate", card).then(r =>{
                console.log( r );
                if( r.success){
                    handleClose();
                }else{
                    alert( r.msg )
                }
            })
        }
    }
    function handleIngressarCard(){
        const dado = {
            id: cartao.id,
        }
        
        Service.POST('/api/security/projeto/kanban/cardIngressar', dado).then(r => {
        if (r.success) {
            action({
                type: TYPES.cardAddMembro,
                dado: r.dado
              });
        } else {
            alert(r.msg);
        }
        }
        );
    }
    function podeArquivar(){
        if(temAcessoAoProjeto(projeto, prof, papeis, [['rootProject', 'ProjectAdm', 'ArquivarCartoes']]))

        return false;
    }
    function membroJaNoCard(){
        if( cartao.membros && prof.profile){
            const item = cartao.membros.find(m => m.login === prof.profile.login);
            if( item) return true;
        }
        return false;
    }
    function handleMover(dado){
        handleClose();
        handleMoverCard(dado);
    }
    function onClickFull(){
        handleFullScreen();
        handleClose();
    }

    return (
        <React.Fragment>
            <Tooltip title="Ações">
                <IconButton aria-label="Ações" disabled={!temAcessoBasico}
                    onClick={handleClick}
                    sx={{ color: blue[500] }}
                >
                    <MoreHoriz fontSize="inherit" />
                </IconButton>
            </Tooltip>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <MenuList>
                    <MenuItem onClick={onClickFull}>
                        <ListItemIcon>
                            <Fullscreen fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Tela cheia</ListItemText>
                    </MenuItem>
                    <KanbanCardMoverMenu 
                        action={handleMover} col={col} kanban={kanban} 
                        cartao={cartao}
                    />
                    { !membroJaNoCard() && 
                    <MenuItem onClick={handleIngressarCard}>
                        <ListItemIcon>
                            <Person fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Ingressar</ListItemText>
                    </MenuItem>}
                    <MenuItem onClick={ handleCriarTemplate}>
                        <ListItemIcon>
                            <PresentToAll fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Criar Template</ListItemText>
                    </MenuItem>
                    <Divider />
                    <MenuItem disabled={!podeArquivar()}>
                        <ListItemIcon>
                            <Archive fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Arquivar</ListItemText>
                    </MenuItem>
                </MenuList>
            </Menu>
        </React.Fragment>
    )
}